<template>
  <div class="fixed top-4 right-4 z-[9999] flex flex-col items-end gap-3 pointer-events-none">
    <transition-group name="toast" tag="div" class="flex flex-col items-end gap-3">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        :class="{
          'bg-emerald-500/10 border-emerald-500/50 text-emerald-400': toast.type === 'success',
          'bg-red-500/10 border-red-500/50 text-red-400': toast.type === 'error',
          'bg-blue-500/10 border-blue-500/50 text-blue-400': toast.type === 'info',
          'bg-amber-500/10 border-amber-500/50 text-amber-400': toast.type === 'warning'
        }"
        class="flex items-center space-x-3 px-4 py-3 rounded-lg border backdrop-blur-md shadow-lg pointer-events-auto w-auto max-w-md min-w-[200px]"
      >
        <i :class="{
          'ph-bold ph-check-circle': toast.type === 'success',
          'ph-bold ph-x-circle': toast.type === 'error',
          'ph-bold ph-info': toast.type === 'info',
          'ph-bold ph-warning': toast.type === 'warning'
        }" class="text-lg flex-shrink-0"></i>
        <span class="text-sm font-medium flex-1 overflow-hidden text-ellipsis whitespace-nowrap">{{ toast.msg }}</span>
        <button @click="$emit('remove', toast.id)" class="ml-2 hover:opacity-70 flex-shrink-0">
          <i class="ph-bold ph-x text-sm"></i>
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script setup>

defineProps({
  toasts: { type: Array, required: true }
});

defineEmits(['remove']);
</script>






